export const ranks = {
  data() {
    return {
      ranks: [
        {
          avatar: "https://picsum.photos/seed/picsum/80/80",
          name: "Mertcan Kose",
          point: 480,
        },
        {
          avatar: "https://picsum.photos/seed/picsum/80/80",
          name: "Dustin James",
          point: 140,
        },
        {
          avatar: "https://picsum.photos/seed/picsum/80/80",
          name: "Santi Keris",
          point: 370,
        },
        {
          avatar: "https://picsum.photos/seed/picsum/80/80",
          name: "Jeremy Thomas",
          point: 120,
        },
        {
          avatar: "https://picsum.photos/seed/picsum/80/80",
          name: "Red John",
          point: 80,
        }
      ],
    }
  },
}